import React, { useEffect, useState, useContext, useRef } from "react"
import { Col, Row, Input, Form, FormFeedback } from "reactstrap"
import thumbnailDefault from "../../../assets/images/ts-core/thumbnail-default.jpg";
import thumbnailAdd from "../../../assets/images/ts-core/thumbnail-add.jpg";
import pdfDefault from "../../../assets/images/ts-core/pdf-default.jpg";
import pdfShow from "../../../assets/images/ts-core/pdf-show.png";

// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"

//import components
import "../../../components/Common/ts-css.css"
import _ from "lodash"
import fn_helper from "helpers/fn_helper"
import moment from "moment"
import DialogCustom from "components/modal/DialogCustom"
import UploadFileS3 from "components/UploadFileS3"
import UploadFileAPI from "components/UploadFileAPI"
import UploadDesc from "components/UploadDesc";
import Select from "react-select"
import ImageComponent from "components/ImageComponent";

const TYPE_LINK_OPTION = [
  { id: "LINK_OUT", name: "Blank" },
  { id: "LINK_IN", name: "Self" }
]

const WebSrc = fn_helper.WEB.webSrc

const PopupAttachment = ({
  label = "",
  description = "",
  prefixName = "",
  upload = "",
  typeDetail = '',
  typeUpload = "",
  widthSize = 0,
  heightSize = 0,
  required = false,
  index = -1,
  value = "",
  onChange = () => console.log('onChange!'),
  onRemove = () => console.log('onRemove!'),
  pageView = 'create',
  isShowLabel = true,
  isAddMode = false,
  mode = ""
}) => {

  // mode
  let LABEL_TITLE = 'Title Attribute'
  let LABEL_ALT = 'Alt Attribute'

  if (["ImageLink"].includes(mode)) {
    LABEL_TITLE = 'URL Link'
    LABEL_ALT = 'Target'
  }
  if (["PdfLink"].includes(mode)) {
    LABEL_TITLE = 'File Name'
  }

  // STATE POPUP
  const [isOpen, setIsOpen] = useState(false)
  const [isSubmit, setIsSubmit] = useState(false)
  const [imageBeforUpload, setImageBeforUpload] = useState(null)
  const [imageUploadDisplay, setImageUploadDisplay] = useState(null)
  const [disableUploadButton, setDisableUploadButton] = useState(true)

  // ========== Form Validation ========== //
  const validationSchema = Yup.object({
    attachmentName: Yup.string().max(1024).required("Please Enter Browse File"),
    attachmentTitle: ["PdfLink", "ImageLink"].includes(mode) ? Yup.string().max(255).required(`Please Enter ${LABEL_TITLE}`) : null,
    // attachmentAlt: Yup.string().max(255).required(`Please Enter ${LABEL_ALT}`),
  })

  // LOCAL STATE FORM
  const [updatedValidationSchema, setUpdatedValidationSchema] = useState(validationSchema)

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      attachmentField: "",
      attachmentName: "",
      attachmentRawName: "",
      attachmentType: "",
      attachmentTitle: "",
      attachmentAlt: ["PdfLink", "ImageLink"].includes(mode) ? "LINK_OUT" : "",
      attachmentExtension: "",
      attachmentSize: "",
      attachmentStatus: "",
    },
    validationSchema: updatedValidationSchema,
    onSubmit: values => {
      console.log("🚀 ~ ArticleCategoryCreate ~ values:", values)
      const payload = {
        attachmentId: values.attachmentId ? values.attachmentId : undefined,

        attachmentField: values.attachmentField,
        attachmentName: values.attachmentName,
        attachmentRawName: values.attachmentRawName,
        attachmentType: values.attachmentType,
        attachmentTitle: values?.attachmentTitle ?? null,
        attachmentAlt: values?.attachmentAlt ?? null,
        attachmentExtension: values.attachmentExtension,
        attachmentSize: values.attachmentSize,
        attachmentStatus: values.attachmentStatus
      };
      console.log("🚀 ~ onSave ~ payload:", payload);

      onSave(payload, index)
    },
  })


  const onClose = () => {
    console.log('onClose')
    setIsSubmit(false)
    setIsOpen(false)
  }

  const onSave = (_values = {}, _index = -1) => {
    console.log('onSave')
    onChange(_values, _index)
    setTimeout(() => onClose(), 200)
  }

  const onCancel = () => {
    console.log('onCancel')
    onClose()
  }

  const onDelete = (_index = -1) => {
    console.log('onClose')
    onRemove(_index)
  }

  const preFilInput = (resData = {}) => {
    console.log("🚀 ~ preFilInput ~ resData:", resData)
    validation.setFieldValue("attachmentId", resData?.attachmentId ? resData?.attachmentId : undefined)

    validation.setFieldValue("attachmentField", resData.attachmentField)
    validation.setFieldValue("attachmentRawName", resData.attachmentRawName)
    validation.setFieldValue("attachmentType", resData.attachmentType)

    validation.setFieldValue("attachmentTitle", resData.attachmentTitle)
    validation.setFieldValue("attachmentAlt", resData.attachmentAlt)
    validation.setFieldValue("attachmentExtension", resData.attachmentExtension)
    validation.setFieldValue("attachmentSize", resData.attachmentSize)
    validation.setFieldValue("attachmentStatus", resData.attachmentStatus)

    setTimeout(() => validation.setFieldValue("attachmentName", resData.attachmentName), 100)
  }

  useEffect(() => {
    if (isOpen) {
      if (value) {
        console.log('preFilInput inside >>', value)
        preFilInput(value)
      }
    }

    return () => {
      if (!isOpen) {
        validation.resetForm();
      } else {
        setTimeout(() => validation.resetForm(), 500);
      }
    }
  }, [isOpen, value])

  // console.log('validation.values XXX >>', validation.values)

  return (
    <>
      {
        isShowLabel && (
          <aside className="b-upload-label">
            <UploadDesc
              upload={upload}
              typeUpload={typeUpload}
              label={label}
              required={required}
              widthSize={widthSize}
              heightSize={heightSize}
              description={description}
            />
          </aside>
        )
      }
      <div className={`b-upload-main ${typeDetail === 'single' ? '' : ''} `}>
        <div className="d-flex justify-content-center">
          <aside className="b-upload-box">
            {
              isAddMode
                ? <img src={thumbnailAdd} alt="thumbnail-add" />
                : (
                  <>
                    {
                      value && value?.attachmentName
                        ? <>
                          {
                            {
                              'PDF': <img src={pdfShow} alt="pdf-show" />,
                              'ImageMap': <ImageComponent src={imageUploadDisplay ?? WebSrc(value.attachmentName)} alt="image-show" />,
                              'VideoMP4': <div className="bVideoUpload" style={{ height: "160px" }}>
                                <div className="bx bx-video-recording bx-lg"></div>
                                <h4>Video File</h4>
                              </div>,
                              'ImageVideoMap': <>
                                {
                                  {
                                    '.mp4': <>
                                      <div className="bVideoUpload" style={{ height: "160px" }}>
                                        <div className="bx bx-video-recording bx-lg"></div>
                                        <h4>Video File</h4>
                                      </div>
                                    </>,
                                    '.jpg': <ImageComponent src={imageUploadDisplay ?? WebSrc(value.attachmentName)} alt="image-show" />,
                                    '.png': <ImageComponent src={imageUploadDisplay ?? WebSrc(value.attachmentName)} alt="image-show" />,
                                  }[value.attachmentExtension]
                                }
                              </>,

                            }[typeUpload]
                          }
                        </>
                        : <>
                          <img src={thumbnailDefault} alt="thumbnail-default" />
                        </>
                      // ? typeUpload === "PDF"
                      //   ? <img src={pdfShow} alt="pdf-show" />
                      //   // : <img src={WebSrc(value.attachmentName)} alt="image-show" />
                      //   : <img src={WebSrc(value.attachmentName)} alt="image-show" />
                      // : typeUpload === "PDF"
                      //   ? <img src={pdfDefault} alt="pdf-default" />
                      //   : <img src={thumbnailDefault} alt="thumbnail-default" />
                      // : typeUpload === "PDF"
                      //   ? <img src={pdfDefault} alt="pdf-default" />
                      //   : <img src={thumbnailDefault} alt="thumbnail-default" />

                    }
                  </>
                )
            }

            {
              value && value?.attachmentName ? (
                typeDetail === 'single'
                  ? <></>
                  : (
                    <>
                    {/* เอาปุ่มลบ vdo ออก เพราะ api อัพเดตไม่ได้ถ้าถูก clear data ก่อน <div className="bnExit" onClick={() => onDelete(index)}>
                   <div className="bx bx-x bx-md"></div>
                     </div> */}
                    </>
                  )
              )
                : < ></>
            }
            <div className="bnTap" onClick={() => setIsOpen(true)} />
          </aside>
        </div>
        {
          value && value?.attachmentName || typeDetail === 'single'
            ? typeDetail === 'single'
              ? typeUpload === "PDF"
                ? (
                  <aside className="b-upload-data">
                    {
                      mode === "PdfLink"
                        ? (
                          <div>
                            <label className="m-0">File Name : </label>
                            <p className="m-0">{value?.attachmentTitle ?? '-'}</p>
                          </div>
                        )
                        : (
                          <div>
                            <label className="m-0">File Size : </label>
                            <p className="m-0">{value?.attachmentSize ? fn_helper.FN.formatBytes(value?.attachmentSize) : '-'}</p>
                          </div>
                        )
                    }

                  </aside>
                )
                : (
                  <aside className="b-upload-data">
                    <div>
                      <label className="m-0">Title Attribute : </label>
                      <p className="m-0">{value?.attachmentTitle ?? '-'}</p>
                    </div>
                    <div>
                      <label className="m-0">Alt Attribute : </label>
                      <p className="m-0">{value?.attachmentAlt ?? '-'}</p>
                    </div>
                  </aside>
                )
              : (
                <label className="m-0">{value?.attachmentRawName ?? '-'}</label>
              )
            : <div style={{ height: 16 }}></div>
        }
      </div>
      <div>
        <DialogCustom visible={isOpen} onHide={() => onClose()} onClickOut={() => onClose()}>
          <div className="modal-group">
            <Form
              className="form-horizontal"
              onSubmit={e => {
                e.preventDefault()
                validation.handleSubmit()
                return false
              }}
            >
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">Image Upload</h5>
              </div>
              {/* {JSON.stringify(validation.values)} */}
              <div className="modal-body" style={{ minHeight: '0px' }}>
                <Row className="mb-3">
                  <Col className="col-12 mb-3">
                    <div className="col-md-12">
                      {/* {validation.values.attachmentExtension} */}
                      {
                        typeUpload === "PDF"
                          ? (
                            <UploadFileAPI
                              bucketName="files"
                              upload="PDF"
                              typeUpload="PDF"
                              prefixName="pdf-file"
                              label="Upload PDF file"
                              required={true}
                              widthSize={1024}
                              heightSize={1024}
                              description="description"
                              value={validation.values.attachmentName}
                              onChange={([imageURL = '', imageSize = '', fileData = {}, imageUploadBase64 = '']) => {
                                console.log("🚀 ~ fileData:", fileData)
                                setImageBeforUpload(imageUploadBase64)
                                validation.setFieldValue("attachmentName", imageURL)
                                validation.setFieldValue("attachmentStatus", 'active')

                                if (fileData?.path) {
                                  const typeFileDot = `${fileData.path}`.substring(`${fileData.path}`.lastIndexOf('.'))
                                  validation.setFieldValue("attachmentRawName", fileData.name)
                                  validation.setFieldValue("attachmentType", fileData.type)
                                  validation.setFieldValue("attachmentExtension", typeFileDot)
                                  validation.setFieldValue("attachmentSize", `${fileData.size}`)
                                }
                              }}
                            />
                          )
                          : (
                            <UploadFileAPI
                              bucketName="images"
                              upload={upload}
                              typeUpload={typeUpload}
                              prefixName={prefixName}
                              label="Browse File"
                              required={true}
                              widthSize={widthSize}
                              heightSize={heightSize}
                              description="description"
                              value={validation.values.attachmentName}
                              onChange={([imageURL = '', imageSize = '', fileData = {}, imageUploadBase64 = '']) => {
                                if (imageUploadBase64 !== '') {
                                  setImageBeforUpload(imageUploadBase64)
                                }

                                console.log("🚀 ~ fileData:", fileData)
                                validation.setFieldValue("attachmentName", imageURL)
                                validation.setFieldValue("attachmentStatus", 'active')

                                if (fileData?.path) {
                                  const typeFileDot = `${fileData.path}`.substring(`${fileData.path}`.lastIndexOf('.'))
                                  validation.setFieldValue("attachmentRawName", fileData.name)
                                  validation.setFieldValue("attachmentType", fileData.type)
                                  validation.setFieldValue("attachmentExtension", typeFileDot)
                                  validation.setFieldValue("attachmentSize", fileData.size)
                                }
                              }}
                              // imageUploadDisplay={imageUploadDisplay}
                              // setImageUploadDisplay={setImageUploadDisplay}
                              setDisableUploadButton={setDisableUploadButton}
                            />
                          )
                      }

                      <Input
                        id="attachmentName"
                        className="form-control"
                        type="text"
                        placeholder=""
                        name="attachmentName"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.attachmentName}
                        invalid={isSubmit && validation.errors.attachmentName ? true : false}
                        readOnly={true}
                        disabled={pageView === "view"}
                      />
                      {
                        isSubmit && validation.errors.attachmentName && (
                          <div type="invalid" className="invalid-feedback d-block">{validation.errors.attachmentName}</div>
                        )
                      }
                    </div>
                  </Col>
                  {
                    typeUpload !== "PDF" || ["PdfLink", "ImageLink"].includes(mode)
                      ? (
                        <>
                          {
                            ["PdfLink", "ImageLink"].includes(mode)
                              ? (
                                <>
                                  <Col className="col-12 mb-3">
                                    <label
                                      htmlFor="category_name"
                                      className="col-md-12 col-form-label"
                                    >
                                      {LABEL_TITLE}
                                      {["PdfLink", "ImageLink"].includes(mode) && (<span className="t-require">*</span>)}
                                    </label>
                                    <div className="col-md-12">
                                      <Input
                                        id="attachmentTitle"
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        name="attachmentTitle"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.attachmentTitle}
                                        invalid={isSubmit && validation.errors.attachmentTitle ? true : false}
                                        disabled={pageView === "view"}
                                      />
                                      {
                                        isSubmit && validation.errors.attachmentTitle && (
                                          <div type="invalid" className="invalid-feedback d-block">{validation.errors.attachmentTitle}</div>
                                        )
                                      }
                                    </div>
                                  </Col>
                                  {
                                    ["PdfLink"].includes(mode) === true
                                      ? <></>
                                      : (
                                        <Col className="col-12 mb-3">
                                          <label
                                            htmlFor="category_name"
                                            className="col-md-12 col-form-label"
                                          >
                                            {LABEL_ALT}
                                            {/* <span className="t-require">*</span> */}
                                          </label>
                                          <div className="col-md-12">
                                            <Select
                                              placeholder="Select Link Type"
                                              value={fn_helper.FNFORM.getObjectValue(TYPE_LINK_OPTION, `${validation.values.attachmentAlt}`)}
                                              onChange={(value) => validation.setFieldValue("attachmentAlt", value.id)}
                                              getOptionValue={(option) => option.id}
                                              getOptionLabel={(option) => option.name}
                                              options={TYPE_LINK_OPTION}
                                              className={`select2-selection ${validation.touched.attachmentAlt && validation.errors.attachmentAlt ? "input-err" : ""}`}
                                              isDisabled={pageView === "view"}
                                            />
                                            {
                                              (validation.touched.attachmentAlt && validation.errors.attachmentAlt) && (
                                                <div type="invalid" className="invalid-feedback d-block">{validation.errors.attachmentAlt}</div>
                                              )
                                            }
                                          </div>
                                        </Col>
                                      )
                                  }

                                </>
                              )
                              : (
                                <>
                                  <Col className="col-12 mb-3">
                                    <label
                                      htmlFor="category_name"
                                      className="col-md-12 col-form-label"
                                    >
                                      Title Attribute
                                      {/* <span className="t-require">*</span> */}
                                    </label>
                                    <div className="col-md-12">
                                      <Input
                                        id="attachmentTitle"
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        name="attachmentTitle"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.attachmentTitle}
                                        invalid={isSubmit && validation.errors.attachmentTitle ? true : false}
                                        disabled={pageView === "view"}
                                      />
                                      {
                                        isSubmit && validation.errors.attachmentTitle && (
                                          <div type="invalid" className="invalid-feedback d-block">{validation.errors.attachmentTitle}</div>
                                        )
                                      }
                                    </div>
                                  </Col>
                                  <Col className="col-12 mb-3">
                                    <label
                                      htmlFor="category_name"
                                      className="col-md-12 col-form-label"
                                    >
                                      Alt Attribute
                                      {/* <span className="t-require">*</span> */}
                                    </label>
                                    <div className="col-md-12">
                                      <Input
                                        id="attachmentAlt"
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        name="attachmentAlt"
                                        onBlur={validation.handleBlur}
                                        onChange={validation.handleChange}
                                        value={validation.values.attachmentAlt}
                                        invalid={isSubmit && validation.errors.attachmentAlt ? true : false}
                                        disabled={pageView === "view"}
                                      />
                                      {
                                        isSubmit && validation.errors.attachmentAlt && (
                                          <div type="invalid" className="invalid-feedback d-block">{validation.errors.attachmentAlt}</div>
                                        )
                                      }
                                    </div>
                                  </Col>
                                </>
                              )
                          }

                        </>
                      )
                      : <></>
                  }

                </Row>
              </div>
              <div className="modal-footer">
                <div style={{ display: 'flex', justifyContent: 'end', gap: '8px' }}>
                  <button type="button" className="btn btn-secondary w-md" onClick={() => onCancel()}>Close</button>
                  <button type="button" className="btn btn-primary w-md" onClick={() => {
                    setIsSubmit(true)
                    validation.handleSubmit()

                    setImageUploadDisplay(imageBeforUpload ?? validation.values.attachmentName)
                  }}>Save</button>
                </div>
              </div>
            </Form>

          </div>

        </DialogCustom>
      </div>
    </>
  )
}
export default PopupAttachment
